import { makeStyles } from '@material-ui/core/styles';

export const useBulkEmailSequenceStepStatusChipStyles = makeStyles(theme => ({
  statusChip: {
    marginLeft: theme.spacing(1)
  }
}));
